import * as React from 'react';
import { Tree } from 'antd';

import { FormItem } from '../../../../components/Form';
import DeliveryMethods from '../../../../components/Query/DeliveryMethods';
import CustomerGroupTree from '../../../../components/Others/CustomerGroupTree';

export interface IValueSettingsColProps {
  domain: string;
  voucherGroup: GQL.IVoucherGroup;
  deliveryMethodsIds: string[];
  customerGroupsIds: string[];
  currentLanguage: string;
  onChange: Function;
}

export interface IValueSettingsColState {
  valueIndex?: any;
}

export default class ValueSettingsCol extends React.Component<IValueSettingsColProps, IValueSettingsColState> {

  public constructor(props: IValueSettingsColProps) {
    super(props);
  }

  public render() {
    const { deliveryMethodsIds, customerGroupsIds } = this.props;

    return (
      <React.Fragment>
        <FormItem label={'Only for customers'}>
          <CustomerGroupTree
            name={'customerGroupsIds'}
            onChange={(e: any, customerGroups: GQL.ICustomerGroup[]) => this.props.onChange(e)}
            value={customerGroupsIds || []}
          />
        </FormItem>
        <FormItem label={'Free shipping'}>
          <DeliveryMethods
            domain={this.props.domain}
          >
            {({ deliveryMethods }: any) => {
              if (deliveryMethods.loading) {
                return <span>Loading...</span>;
              }

              return (
                <Tree
                  onCheck={(checkedKeys: any) => this.props.onChange({ target: { name: 'deliveryMethodsIds', value: checkedKeys.checked } })}
                  onSelect={(checkedKeys: any) => this.props.onChange({ target: { name: 'deliveryMethodsIds', value: checkedKeys } })}
                  selectedKeys={deliveryMethodsIds}
                  checkedKeys={deliveryMethodsIds}
                  multiple={true}
                  checkable={true}
                  checkStrictly={true}
                  treeData={deliveryMethods.deliveryMethods.map((p: GQL.IVoucherGroup) => {
                    p.key = p.id
                    return p;
                  })}
                />
              );
            }}
          </DeliveryMethods>
        </FormItem>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/StaticVoucherGroups/VoucherGroupDetail/components/Values.tsx